module.exports = __webpack_public_path__ + "static/media/gi.41325281.svg";